import {launchWhatsAppSignup} from "../../utils/meta/launchWhatsAppSignup";
import FacebookLogo from "../../assets/images/facebook-logo.png";
import React, {useEffect, useState} from "react";
import useUserContext from "../../hooks/useUserContext";
import "./whatsapp-integration-button.css";
import { twilioEmbeddedSignupInfoListener } from "../../utils/meta/sessionInfoListener";
import useAppContext from "../../hooks/useAppContext";
import {getShopifyShopDetails} from "../../api/getShopifyShopDetails";

interface WhatsappIntegrationButtonProps {
    shouldDisplayPhoneDialog?: boolean;
    byonNumber?: string;
    byonCode?: number;
    lang?: "en" | "he";
    onCompleteMetaOnboarding?: () => void;
    onFailMetaOnboarding?: () => void;
    onStartMetaOnboarding?: () => void;
}

export interface ShopDetailsProps {
    name?: string;
    email?: string;
    website?: string;
    country?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string;
    phoneCode?: number;
    phoneNumber?: string;
    timezone?: string;
}

const BUTTON_LABEL: Record<"en" | "he", string> = {
    en: "Connect Whatsapp Business Account",
    he: "חברו חשבון WhatsApp Business",
};

const WhatsappIntegrationButton = ({ shouldDisplayPhoneDialog = false, byonCode, byonNumber, lang = "en", onCompleteMetaOnboarding, onFailMetaOnboarding, onStartMetaOnboarding }: WhatsappIntegrationButtonProps) => {
    const { selectedDomain } = useUserContext();
    const { actions: { loadWaba }, data: { shop } } = useAppContext();
    const [shopDetails, setShopDetails] = useState<ShopDetailsProps>({});
    const [isLoading, setIsLoading] = useState(false);
    const [isInMetaEmbedded, setIsInMetaEmbedded] = useState(false);
    const [metaResolved, setMetaResolved] = useState(false);

    const handleMetaCompleted = () => {
        setMetaResolved(true);
        onCompleteMetaOnboarding && onCompleteMetaOnboarding();
    };

    const handleMetaFailed = () => {
        if (metaResolved) return;
        onFailMetaOnboarding && onFailMetaOnboarding();
    };

    const getShopDetails = async () => {
        if(!selectedDomain) return;
        const response = await getShopifyShopDetails(selectedDomain);
        // console.log("response: ", response);
        if(response.data) {
            setShopDetails({
                name: response.data.name || undefined,
                email: response.data.email || undefined,
                website: response.data.domain || undefined,
                country: response.data.country || undefined,
                address1: response.data.address1 || undefined,
                address2: response.data.address2 || undefined,
                city: response.data.city || undefined,
                state: response.data.state || undefined,
                zip: response.data.zip || undefined,
                phoneCode: byonCode,
                phoneNumber: byonNumber,
                timezone: response.data.timezone,
            });
        }
    }

    useEffect(() => {
        getShopDetails();
        // console.log("about to addEventListener twilioEmbeddedSignupInfoListener");
        const callback = twilioEmbeddedSignupInfoListener({
            loadWaba,
            onCompleteMetaOnboarding: handleMetaCompleted,
            onFailMetaOnboarding: handleMetaFailed,
            selectedDomain,
            setIsLoading,
            setIsInMetaEmbedded
        });
        window.addEventListener('message', callback);
        return () => {
            // console.log("about to removeEventListener twilioEmbeddedSignupInfoListener")
            window.removeEventListener('message', callback);
        }
    }, [selectedDomain, metaResolved, onCompleteMetaOnboarding, onFailMetaOnboarding]);

    return (
        <div className="facebook-login-button" style={(isInMetaEmbedded || isLoading) ? { pointerEvents: "none", opacity: 0.6 } : undefined} onClick={() => {
            if (isInMetaEmbedded || isLoading) return;
            setMetaResolved(false);
            onStartMetaOnboarding && onStartMetaOnboarding();
            setIsInMetaEmbedded(true);
            launchWhatsAppSignup({
                loadWaba,
                selectedDomain,
                shouldDisplayPhoneDialog,
                shopDetails,
                shop: shop.data,
                isLoading: isInMetaEmbedded,
                setIsLoading: setIsInMetaEmbedded,
                onFailMetaOnboarding: handleMetaFailed,
            });
        }}>
            <img className={`facebook-logo${lang === "he" ? " facebook-logo-rtl" : ""}`} src={FacebookLogo} /> <div>{BUTTON_LABEL[lang]}</div>
        </div>
    );
}

export default WhatsappIntegrationButton;
